import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

const PLATFORM_ROOT_DOMAIN = process.env.REACT_APP_PLATFORM_ROOT_DOMAIN || "filagestao.com.br";
const DEFAULT_TENANT_SLUG = process.env.REACT_APP_DEFAULT_TENANT_SLUG || "";

// Segmentos globais da plataforma (não são slugs de tenant)
const RESERVED_SEGMENTS = new Set(["super", "api", "static", "assets", "login", "logout", "entrar", ""]);

// Slug obedecendo o mesmo regex do backend (a-z0-9 + hífen)
const SLUG_RE = /^[a-z0-9](?:[a-z0-9-]{0,30}[a-z0-9])?$/;

function _isProductionRoot() {
  // Consideramos "produção root" quando o hostname é EXATAMENTE o domínio raiz
  // da plataforma (ou www.<raiz>). Neste ambiente NÃO aplicamos fallback lerose.
  if (typeof window === "undefined") return false;
  const host = window.location.hostname.toLowerCase();
  return host === PLATFORM_ROOT_DOMAIN || host === `www.${PLATFORM_ROOT_DOMAIN}`;
}

/**
 * Resolve o slug do tenant em cascata:
 *   1) Primeiro segmento do path da URL atual (produção path-based)
 *   2) Subdomínio <slug>.filagestao.com.br (compat futuro)
 *   3) REACT_APP_DEFAULT_TENANT_SLUG (SOMENTE preview/dev — NUNCA em produção)
 */
export function resolveTenantSlug() {
  if (typeof window === "undefined") return _isProductionRoot() ? null : (DEFAULT_TENANT_SLUG || null);

  // 1) Path-based
  const parts = window.location.pathname.split("/").filter(Boolean);
  const first = (parts[0] || "").toLowerCase();
  if (first && !RESERVED_SEGMENTS.has(first) && SLUG_RE.test(first)) {
    return first;
  }

  // 2) Subdomínio (compat futuro)
  const host = window.location.hostname.toLowerCase();
  if (host.endsWith("." + PLATFORM_ROOT_DOMAIN)) {
    const sub = host.slice(0, -(PLATFORM_ROOT_DOMAIN.length + 1));
    if (sub && !sub.includes(".") && !["www", "app", "api"].includes(sub) && SLUG_RE.test(sub)) return sub;
  }

  // 3) Fallback SOMENTE em preview/dev — nunca no domínio de produção
  if (_isProductionRoot()) return null;
  return DEFAULT_TENANT_SLUG || null;
}

const api = axios.create({ baseURL: API });

api.interceptors.request.use((config) => {
  const url = config.url || "";
  const isSuper = url.startsWith("/super") || url.startsWith("super");
  // Modo Suporte usa sessionStorage (por aba) para não colidir com o token normal.
  // Endpoints /support/* também usam o token de suporte quando presente.
  const isSupportRoute = url.startsWith("/support") || url.startsWith("support");
  const supportToken = typeof sessionStorage !== "undefined" ? sessionStorage.getItem("flr_support_token") : null;
  if (isSuper) {
    const t = localStorage.getItem("flr_super_token");
    if (t) config.headers.Authorization = `Bearer ${t}`;
  } else if (supportToken) {
    // Token de suporte tem precedência sobre o token normal do usuário na aba.
    config.headers.Authorization = `Bearer ${supportToken}`;
    // NÃO enviar X-Tenant-Slug — o backend força o tenant pelo token de suporte.
  } else {
    const t = localStorage.getItem("flr_token");
    if (t) config.headers.Authorization = `Bearer ${t}`;
    const slug = resolveTenantSlug();
    if (slug) config.headers["X-Tenant-Slug"] = slug;
  }
  // eslint-disable-next-line no-unused-vars
  const _debug = isSupportRoute;
  return config;
});

export function formatApiError(err) {
  const d = err?.response?.data?.detail;
  if (!d) return err?.message || "Erro desconhecido";
  if (typeof d === "string") return d;
  if (Array.isArray(d)) return d.map((e) => e?.msg || JSON.stringify(e)).join(" ");
  return String(d);
}

export default api;
